<template>
	<div class="setting-mine-content">
		<ul class="tab-box">
			<li v-for="(item, index) in tabList" :key="item.value" @click="changeIndex(index)" :class="{active: tabIndex === item.value}">{{item.label}}</li>
		</ul>
		<div class="tab-content">
			<div class="tab-item" v-if="tabIndex === 0 && finish">
				<div class="modify-avatar-box">
					<my-upload field="uploadFile"
						@crop-upload-success="cropUploadSuccess"
						@crop-upload-fail="cropUploadFail"
						v-model="show"
						:width="200"
						:height="200"
						:url="upLoadUrl_"
						:params="params"
						:headers="headers"
						img-format="png"></my-upload>
					<img class="poster-image" :src="headImage | imgUrl('url')" />
					<button class="modify-avatar" @click="toggleShow">修改头像</button>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">姓名:</span>
					<input class="input-row__input" v-model="modifyInfo.realname" />
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">性别:</span>
					<div class="input-row__input">
						<label><input type="radio" @change="chengeGender(1)" :checked="modifyInfo.gender === 1" name="sex" value="1" />男</label>
						<label><input type="radio" @change="chengeGender(2)" :checked="modifyInfo.gender === 2" name="sex" value="2" />女</label>
					</div>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">生日:</span>
					<div class="input-row__input">
						<select class="input-row__input input-row__input_sm" v-model="year" @change="changeBirthday">
							<option disabled="disabled" checked="checked">年</option>
							<option v-for="item in yearList" :key="item" :value="item">{{item}}年</option>
						</select>
						<select class="input-row__input input-row__input_sm" v-model="month" @change="changeBirthday">
							<option disabled="" checked="checked" value="0">月</option>
							<option v-for="item in monthList_" :key="item" checked="0" :value="item">{{item}}月</option>
						</select>
						<select class="input-row__input input-row__input_sm" v-model="day" @change="changeBirthday">
							<option disabled="disabled" checked="checked">日</option>
							<option v-for="item in dayList_" :key="item" :value="item">{{item}}日</option>
						</select>
					</div>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">地区:</span>
					<div class="input-row__input input-row__input_area">
						<city-picker :default-city="defaultCity_" @choice-caller="changeArea"></city-picker>
					</div>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">详细地址:</span>
					<textarea class="input-row__input" v-model="modifyInfo.address" placeholder="请输入详细地址"></textarea>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label">兴趣:</span>
					<div class="input-row__input input-row__input_skill">
						<ul class="type-list clearfix">
							<li v-for="(item, index) in skillList" :key="index">
								<label>
									<input type="checkbox" name="skill" :value="item.value" @change="changeCheck(index, 'skillList')" :checked="item.checked" />{{item.value}}
								</label>
							</li>
						</ul>
					</div>
				</div>
				<div class="input-row clearfix">
					<span class="input-row__label"></span>
					<div class="input-row__input">
						<button class="save-btn" @click="updateUserInfo" :class="[disabled ? 'btn-disabled':'btn-primary']">保存</button>
					</div>
				</div>
			</div>
			<div class="tab-item type-select-box" v-else-if="tabIndex === 1">
				<div class="type-title">建议多选几个感兴趣的分类，我们会更精准的推荐相关内容哦！</div>
				<ul class="type-list clearfix">
					<li v-for="(item, index) in tagList" :key="index">
						<label>
							<input type="checkbox" name="type" :value="item.id" @change="changeCheck(index, 'tagList')" :checked="item.isSelected" />{{item.tagName}}
						</label>
					</li>
				</ul>
				<button class="save-btn btn-primary" @click="save">保存</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import cityPicker from '@/components/cityPicker/cityPicker.vue'
	import myUpload from 'vue-image-crop-upload'
	import { getLoginInfo } from '@/api/config.js'
	import { PROXY_NAME, BASE_URL } from '@/config'
	export default {
		components: {
			cityPicker,
			myUpload
		},
		data() {
			return {
				tabList: [
					{
						value: 0,
						label: '基本信息'
					},
					{
						value: 1,
						label: '兴趣分类'
					}
				],
				tagList: [],
				tabIndex: 0,
				yearList: [],
				monthList:[],
				year: '',
				month: '',
				day: '',
				userInfo: {},
				skillList: [],
				modifyInfo: {},
				headImage: {},
				disabled: false,
				finish: false,
				show: false,
				params: {
					addToRes: false,
					'JEECMS-Auth-Token': getLoginInfo()['JEECMS-Auth-Token'] || '',
					'Redirect-Header': false,
					'Content-Type': 'application/json',
					'typeStr':'Image'
				},
				headers: {
					// smail: '*_~',
					'JEECMS-Auth-Token': getLoginInfo()['JEECMS-Auth-Token'] || '',
				},
			}
		},
		computed: {
			upLoadUrl_() {
				let url = '/member/upload/o_upload'
				if(process.env.NODE_ENV === 'development'){
					url = PROXY_NAME + url;
				}else{
					url = BASE_URL + url;
					// url = url;
				}
				return url;
			},
			monthList_() {
				if(!this.year) return [];
				return this.monthList;
			},
			dayList_() {
				if(!this.year || !this.month) return [];
				let len = this.getMonthDay(this.year, this.month);
				return this.getArr(1, len);
			},
			birthday_() {
				return this.year + '-' + this.month + '-' + this.day;
			},
			areaArr_(){
				let pickerText = [];
				if (this.modifyInfo.province) {
					pickerText.push(this.modifyInfo.province);
					this.modifyInfo.city && pickerText.push(this.modifyInfo.city);
					this.modifyInfo.county && pickerText.push(this.modifyInfo.county);
				}
				return  pickerText;
			},
			pickerText_() {
				return this.areaArr_.join('-');
			},
			defaultCity_() {
				return this.areaArr_.join(',');
			}
		},
		watch: {
			modifyInfo: {
				handler(val) {
					this.disabled = this.$diffByObj(this.userInfo, val);
				},
				deep: true
			}
		},
		created() {
			this.getUserInfo();
			this.yearList = this.getArr().reverse();
			this.monthList = this.getArr(1, 12);
			this.getTagList();
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			chengeGender(e) {
				this.modifyInfo.gender = e;
			},
			// 修改头像开始
			toggleShow() {
				this.show = !this.show;
			},
			/**
			 * upload success
			 *
			 * [param] jsonData  server api return data, already json encode
			 * [param] field
			 */
			async cropUploadSuccess(res, field){
				let res1 = await this.$http('memberinfoCustom', {
					attrName: 'headerImg',
					attrType: 'imageUpload',
					attrValue: res.data.resourceId
				})
				if (res1.code === 1) {
					this.headImage.url = res.data.fileUrl;
				}
			},
			/**
			 * upload fail
			 *
			 * [param] status    server api return error status, like 500
			 * [param] field
			 */
			cropUploadFail(status, field){
				this.$toast('上传失败')
			},
			// 修改头像结束
			async save() {
				if(this.disabled_) return this.$toast('至少选择一个标签');
				let selectArr = this.tagList.filter(o => o.checked || o.isSelected).map(o => o.tagId);
				await this.$http('selectTags', {
					tagIds: selectArr.join(',')
				});
				this.getUserInfo(false);
				this.getTagList();
			},
			changeCheck(index, pro = 'tagList'){
        if(pro === 'tagList'){
          this.$set(this[pro][index], 'isSelected', !this[pro][index].isSelected);
        }else{
          this.$set(this[pro][index], 'checked', !this[pro][index].checked);
          this.modifyInfo.skills = this[pro].filter(o => o.checked).map(o => o.value).join(',');
        }
			},
			async getTagList() {
				this.selectArr = [];
				let res = await this.$http('tagList');
				if(res.code === 1){
					this.tagList = res.data;
				}
			},
			changeIndex(index) {
				this.tabIndex = index;
			},
			changeBirthday() {
				this.$nextTick(() => {
					this.modifyInfo.birthday = this.birthday_;
				})
			},
			async updateUserInfo() {
				if (this.disabled) return;
				let params = { ...this.modifyInfo};

				if(params.idCard && !this.validateIdCard(params.idCard)) return this.$toast('身份证格式不正确');
				// 验证传入的生日日期是否正确
				let birthday = params.birthday;
				if (birthday == "-1-12-30"){
					params.birthday = '';
				}else {
					let date = new Date(birthday);
					if(date.getFullYear() !== Number(this.year) || date.getMonth() !== Number(this.month) - 1 || date.getDate() !== Number(this.day)){
						return this.$toast('生日日期不正确');
					}
				}
				let res = await this.$http('updateUserInfo', params);
				if (res.code === 1) this.getUserInfo();
			},
			handleTap() {
				var index = this.$refs.simpleAddress.queryIndex([this.modifyInfo.province, this.modifyInfo.city, this.modifyInfo.county],
					'label');
				this.cityPickerValueDefault = index.index;
				this.$refs.simpleAddress.open();
			},
			changeSex(sex) {
				this.modifyInfo.gender = this.modifyInfo.gender === sex ? 3 : sex;
			},
			changeArea(e) {
				let pros = ['province', 'city', 'county']
				this.modifyInfo[pros[e[2]]] = e[0];
			},
			async getUserInfo() {
				let data = await this.GetUserInfoHandle(false);
				let skills = data.skills || '';
				this.skillList = data.skillList.map(o => {
					return {
						value: o,
						checked: skills.indexOf(o) !== -1
					}
				})
				delete data.skillList;
				Object.keys(data).forEach(o => data[o] = data[o] ? data[o] : '');
				data.birthday = !data.birthday ? 0 : this.$options.filters['time'](data.birthday, 'date');
				if(data.birthday){
					let birthday = data.birthday.split('-');
					this.year = birthday[0];
					this.month = birthday[1];
					this.day = birthday[2];
				}
				this.userInfo = this.$deepClone(data);
				this.modifyInfo = this.$deepClone(data);
				this.headImage = {
					url: data.headImage
				}
				this.finish = true;
			},
			validateIdCard(idCard) {
				//15位和18位身份证号码的正则表达式
				var regIdCard =
					/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
				//如果通过该验证，说明身份证格式正确，但准确性还需计算
				if (regIdCard.test(idCard)) {
					if (idCard.length == 18) {
						var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
						var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
						var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
						for (var i = 0; i < 17; i++) {
							idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
						}
						var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
						var idCardLast = idCard.substring(17); //得到最后一位身份证号码
						//如果等于2，则说明校验码是10，身份证号码最后一位应该是X
						if (idCardMod == 2) {
							if (idCardLast == "X" || idCardLast == "x") {
								return true;
							} else {
								return false;
							}
						} else {
							//用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
							if (idCardLast == idCardY[idCardMod]) {
								return true;
							} else {
								return false;
							}
						}
					}
				} else {
					return false;
				}
			},
			getArr(star = 1970, end = new Date().getFullYear()) {
				let yearList = [];
				let date = new Date();  //先new出一个date对象
				for(var i = star; i <= end; i++){   //获取当前年份
					yearList.push(this.zeroize(i));
				}
				return yearList;
			},
			getMonthDay(year, month) {

			  let days = new Date(year, month, 0).getDate()
			  return days
			},
			zeroize(num) {
				return num > 9 ? String(num) : ('0' + num);
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.setting-mine-content{
		padding: 28px 30px;
		.tab-item{
			padding: 30px;
		}
		.type-list{
			padding-right: 0;
			li{
				white-space: nowrap;
				float: left!important;
				min-width: 125px;
				width: auto;
				padding: 0 15px;
				margin-right: 45px!important;
				white-space: nowrap;
				label{
					display: block;
				}
			}
		}
		.type-select-box{
			.type-title{
				font-size: 18px;
				font-weight: 400;
				color: #666666;
				line-height: 38px;
			}
			.save-btn{
				margin: 82px auto 0;
			}
		}

		.save-btn {
			display: block;
			width: 337px;
			height: 44px;
			border-radius: 3px;
			font-size: 18px;
			line-height: 44px;
		}
		.input-row{
			margin-top: 20px;
			.input-row__label{
				width: 100px;
				display: inline-block;
				float: left;
				font-size: 18px;
				font-weight: 400;
				color: #333333;
				line-height: 44px;
				height: 44px;
				text-align: right;
				padding-right: 20px;
			}
			.input-row__input{
				width: 380px;
				height: 44px;
				background-color: #FFFFFF;
				border: 1px solid #DDDDDD;
				border-radius: 3px;
				float: left;
				padding: 0 20px 0 10px;
				line-height: 42px;
				font-size: 15px;
				font-weight: 400;
				color: #757575;
				&.input-row__input_skill{
					height: auto;
					width: 676px;
					padding-right: 0;
				}
				.type-list{
					padding-right: 0;
					li{
						margin-right: 30px!important;
					}
					label{
						margin-right: 0;
					}
				}
				&.input-row__input_area{
					padding-right: 0;
					::v-deep .city-picker-item{
						width: 120px;
						input{
							height: 44px;
							line-height: 42px;
						}
						.city-picker-list .caller{
							line-height: 20px;
						}
					}
				}
				&:disabled{
					background-color: #F4F4F4;
				}
				.input-row__input_sm{
					width: 33.3333333%;
					float: left;
					margin-right: 10px;
					&:nth-of-type(3n){
						float: right;
						margin-right: -20px;
					}
				}
				label{
					font-size: 15px;
					font-weight: 400;
					color: #757575;
					margin-right: 50px;
					input{
						margin-top: -4px;
						margin-right: 8px;
					}
				}
			}
			div.input-row__input{
				padding-left: 0;
				border: none;
				line-height: 44px;
			}
			textarea.input-row__input{
				height: 90px;
				resize: none;
			}
		}
		.modify-avatar-box{
			padding-top: 15px;
			padding-bottom: 10px;
			padding-left: 100px;
			width: 228px;
			img{
				border-radius: 100%;
				width: 128px;
				height: 128px;
				display: block;
				margin: 0 auto;
			}
			.modify-avatar{
				display: block;
				width: 90px;
				height: 30px;
				margin: 13px auto 0;
				background: #FFFFFF;
				border: 1px solid #B7D2FF;
				border-radius: 5px;
				text-align: center;
				font-size: 14px;
				font-weight: 400;
				color: #035FFE;
				line-height: 28px;
			}
		}
		.tab-content{
			border: 1px solid #DDDDDD;
			min-height: 866px;
		}
		.tab-box{
			li{
				cursor: pointer;
				display: inline-block;
				margin-right: 10px;
				width: 145px;
				height: 55px;
				background: #FFFFFF;
				border: 1px solid #DDDDDD;
				position: relative;
				z-index: 2;
				margin-bottom: -1px;
				text-align: center;
				line-height: 55px;
				font-size: 20px;
				font-weight: 400;
				color: #484848;
				&.active{
					color: #1A6FFE;
					border-bottom: 0;
					&::after{
						content: '';
						@include abs(-5px, 0, null, 0);
						height: 5px;
						background: #1A6FFE;
					}
				}
			}
		}
	}
</style>
